import styled from 'astroturf';
import React from 'react';

import { graphql, Link, useStaticQuery } from 'gatsby';
import Img, { FluidObject } from 'gatsby-image';

const Container = /*#__PURE__*/styled("ul", null, {
  displayName: "Container",
  styles: require("./AccessoryTabPage-Container.module.css"),
  attrs: null,
  vars: []
});

const ThumbnailWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "ThumbnailWrapper",
  styles: require("./AccessoryTabPage-ThumbnailWrapper.module.css"),
  attrs: null,
  vars: []
});

const Name = /*#__PURE__*/styled("p", null, {
  displayName: "Name",
  styles: require("./AccessoryTabPage-Name.module.css"),
  attrs: null,
  vars: []
});

interface Props {
  items: {
    slug: string;
    name: string;
    fluid: FluidObject;
  }[];
}

export default function AccessoryTabPage(props: Props) {
  return (
    <Container>
      {props.items.map(({ slug, name, fluid }) => (
        <li key={slug}>
          <Link to={`/accessories/${slug}/`}>
            <ThumbnailWrapper>
              <Img fluid={fluid} />
            </ThumbnailWrapper>
            <Name>{name}</Name>
          </Link>
        </li>
      ))}
    </Container>
  );
}
